import SeoHelper from './lib/SeoHelper.js';
import TextUtils from './lib/TextUtils.js';
import Markup from './lib/Markup.js';

const checks = [
	{
		id: 'too-long-sentences',
		label: window?.t?.CHECK_TOO_LONG_SENTENCES,
		section: 'content',
		test: (pageContent, settings) => {
			let {content} = pageContent;
			if (!content) {
				return {
					status: true
				};
			}
			content = content.replaceAll('</p>', '.</p>');
			content = content.replaceAll('</h1>', '.</h1>');
			content = content.replaceAll('</h2>', '.</h2>');
			content = content.replaceAll('</h3>', '.</h3>');
			content = content.replaceAll('</h4>', '.</h4>');
			content = content.replaceAll('</h5>', '.</h5>');
			content = content.replaceAll('</h6>', '.</h6>');
			content = content.replaceAll('</li>', '.</li>');
			content = Markup.stripTags(content);
			const sentences = content.split(/\.|\?|!/).filter((s) => !!s.trim());
			var tooLongSentences = false;
			if (sentences && sentences.length) {
				sentences.forEach((s) => {
					if (!tooLongSentences) {
						let wordCount = TextUtils.countWords(s);
						tooLongSentences = wordCount > parseInt(settings.maxWordsPerSentence);
					}
				});
			}
			return {
				status: !tooLongSentences
			}
		},
		showProblem: (settings, content) => {
			if (!content) {
				return false;
			}
			const markup = Markup.createMarkupEl(SeoHelper.unmarkText(content));

			content = content.replaceAll('</p>', '.</p>');
			content = content.replaceAll('</h1>', '.</h1>');
			content = content.replaceAll('</h2>', '.</h2>');
			content = content.replaceAll('</h3>', '.</h3>');
			content = content.replaceAll('</h4>', '.</h4>');
			content = content.replaceAll('</h5>', '.</h5>');
			content = content.replaceAll('</h6>', '.</h6>');
			content = content.replaceAll('</li>', '.</li>');

			let clearedContent = content
				.replaceAll('<p>', '')
				.replaceAll('</p>', '')
				.replaceAll('<h1>', '')
				.replaceAll('</h1>', '')
				.replaceAll('<h2>', '')
				.replaceAll('</h2>', '')
				.replaceAll('<h3>', '')
				.replaceAll('</h3>', '')
				.replaceAll('<h4>', '')
				.replaceAll('</h4>', '')
				.replaceAll('<h5>', '')
				.replaceAll('</h5>', '')
				.replaceAll('<h6>', '')
				.replaceAll('</h6>', '')
				.replaceAll('<li>', '')
				.replaceAll('</li>', '')
				.replaceAll('<ul>', '')
				.replaceAll('</ul>', '')
				.replaceAll('<ol>', '')
				.replaceAll('</ol>', '');

			const originalSentences = clearedContent.split(/\.|\?|!/).filter((s) => !!s.trim());

			if (originalSentences && originalSentences.length) {
				content = Markup.stripTags(content);

				const sentences = content.split(/\.|\?|!/).filter((s) => !!s.trim());

				sentences.forEach((s) => {
					if (TextUtils.countWords(s) > parseInt(settings.maxWordsPerSentence)) {
						s = s.trim();
						for (let i = 0; i < originalSentences.length; i++) {
							let clearedOriginal = Markup.stripTags(originalSentences[i]).trim();
							if (clearedOriginal === s) {
								markup.innerHTML = markup.innerHTML.replaceAll(originalSentences[i], `<mark>${originalSentences[i]}</mark>`);
							}
						}
					}
				});

				return markup.innerHTML !== content ? markup.innerHTML : false;
			}
		},
		problemInfo: (el) => {
			if (el.tagName !== 'mark') {
				el = el.closest('mark');
			}
			let wordCount = el ? TextUtils.countWords(el.textContent) : 0;
			return wordCount + ' ' + window?.t?.WORDS;
		}
	},
	{
		id: 'too-many-words',
		label: window?.t?.CHECK_TOO_MANY_WORDS,
		section: 'content',
		test: (pageContent, settings) => {

			const markup = Markup.createMarkupEl(pageContent.content);
			const paragraphs = markup.querySelectorAll('p');

			var tooManyWords = false;

			if (paragraphs.length) {
				paragraphs.forEach((p) => {
					if (TextUtils.countWords(p.textContent) > parseInt(settings.maxWordsPerParagraph)) {
						tooManyWords = true;
					}
				});
			}

			return {
				status: !tooManyWords
			}
		},
		showProblem: (settings, content) => {
			const markup = Markup.createMarkupEl(content);
			const paragraphs = markup.querySelectorAll('p');
			paragraphs.forEach((p) => {
				let wordCount = TextUtils.countWords(p.textContent);
				if (wordCount > parseInt(settings.maxWordsPerParagraph)) {
					let pContent = p.innerHTML;
					p.innerHTML = `<mark>${pContent}</mark>`;
				} else {
					p.innerHTML = p.innerHTML.replaceAll('<mark>', '').replaceAll('</mark>', '');
				}
			});
			return markup.innerHTML !== content ? markup.innerHTML : false;
		},
		problemInfo: (el) => {
			if (el.tagName !== 'p') {
				el = el.closest('p');
			}
			return TextUtils.countWords(el.textContent) + ' ' + window?.t?.WORDS;
		}
	},
	{
		id: 'too-many-sentences',
		label: window?.t?.CHECK_TOO_MANY_SENTENCES,
		section: 'content',
		test: (pageContent, settings) => {
			const markup = Markup.createMarkupEl(pageContent.content);
			const paragraphs = markup.querySelectorAll('p');

			var tooManySentences = false;

			if (paragraphs.length) {
				paragraphs.forEach((p) => {
					var sentences = p.textContent.split(/\. |\? |!/);
					sentences = sentences.filter((el) => {
						return !!el.trim();
					});

					if (sentences.length > parseInt(settings.maxSentencesPerParagraph)) {
						tooManySentences = true;
					}
				});
			}

			return {
				status: !tooManySentences
			}
		},
		showProblem: (settings, content) => {
			const markup = Markup.createMarkupEl(content);
			const paragraphs = markup.querySelectorAll('p');

			paragraphs.forEach((p) => {
				var sentences = p.textContent.split(/\. |\? |! /);
				sentences = sentences.filter((s) => {
					return !!s.trim();
				});
				if (sentences.length > parseInt(settings.maxSentencesPerParagraph)) {
					let pContent = p.innerHTML;
					p.innerHTML = `<mark>${pContent}</mark>`;
				} else {
					p.innerHTML = p.innerHTML.replaceAll('<mark>', '').replaceAll('</mark>', '');
				}
			});
			let result = markup.innerHTML !== content ? markup.innerHTML : content;
			return result;
		},
		problemInfo: (el) => {
			if (el.tagName !== 'p') {
				el = el.closest('p');
			}
			var sentences = el.textContent.split(/\. |\? |! /);
			sentences = sentences.filter((s) => {
				return !!s.trim();
			});
			return `${sentences.length} ${window?.t?.SENTENCES}`;
		}
	},
	{
		id: 'max-words-in-first-p',
		label: window?.t?.CHECK_MAX_WORDS_IN_FIRST_P,
		section: 'content',
		inPro: true,
		test: (inputData, settings) => {
			const markup = document.createElement('div');
			markup.innerHTML = inputData.content;
			const firstP = markup.querySelector('p');
			if (!firstP) {
				return {
					status: true,
				}
			}
			let wordCount = TextUtils.countWords(firstP.textContent);
			return {
				status: wordCount <= parseInt(settings.maxWordsInIntro),
			}
		},
		showProblem: (settings, content) => {
			const markup = Markup.createMarkupEl(content);
			const paragraph = markup.querySelector('p');
			let wordCount = TextUtils.countWords(paragraph.textContent);
			if (wordCount > settings.maxWordsInIntro) {
				let pContent = paragraph.innerHTML;
				paragraph.innerHTML = `<mark>${pContent}</mark>`;
			} else {
				paragraph.innerHTML = paragraph.innerHTML.replaceAll('<mark>', '').replaceAll('</mark>', '');
			}
			return markup.innerHTML !== content ? markup.innerHTML : content;
		},
		problemInfo: (el) => {
			if (!el) {
				return '';
			}
			let wordCount = TextUtils.countWords(el.textContent);
			return `${wordCount} ${window?.t?.WORDS}`;
		}
	},
	{
		id: 'heading-length',
		label: window?.t?.CHECK_HEADING_LENGTH,
		section: 'content',
		inPro: true,
		test: (inputData, settings) => {
			const markup = document.createElement('div');
			markup.innerHTML = inputData.content;
			const wordLimit = 10;
			const headings = markup.querySelectorAll('h1, h2, h3, h4, h5, h6');

			let status = true;
			if (headings) {
				headings.forEach((heading) => {
					var words = TextUtils.countWords(heading.textContent);
					if (words > wordLimit) {
						status = false;
					}
				});
			}
			return  {
				status: status
			};
		},
		showProblem: (settings, content) => {
			const markup = Markup.createMarkupEl(content);
			const headings = markup.querySelectorAll('h1, h2, h3, h4, h5, h6');
			const wordLimit = 10;

			headings.forEach((heading) => {
				let wordCount = TextUtils.countWords(heading.textContent);
				if (wordCount > wordLimit) {
					let hContent = heading.innerHTML;
					heading.innerHTML = `<mark>${hContent}</mark>`;
				} else {
					heading.innerHTML = heading.innerHTML.replaceAll('<mark>', '').replaceAll('</mark>', '');
				}
			});
			return markup.innerHTML !== content ? markup.innerHTML : content;
		},
		problemInfo: (el) => {
			return `${TextUtils.countWords(el.textContent)} ${window?.t?.WORDS}`;
		}
	},
	{
		id: 'heading-separation',
		label: window?.t?.CHECK_HEADING_SEPARATION,
		section: 'content',
		inPro: true,
		test: (pageContent, settings) => {
			let {content} = pageContent;
			const markup = Markup.createMarkupEl(content);

			const elements = markup.querySelectorAll('p, h1, h2, h3, h4, h5, h6');
			let pCount = 0;
			let status = true;
			elements.forEach(el => {
				if (el.tagName.toLowerCase() === 'p' && el.textContent.trim() !== '') {
					pCount ++;
					if (pCount > parseInt(settings.maxParagraphsPerHeading)) {
						status = false;
					}
				} else {
					pCount = 0;
				}
			});
			return  {
				status: status
			};
		}
	},
	{
		id: 'strong-present',
		label: window?.t?.CHECK_STRONG_PRESENT,
		section: 'content',
		test: (pageContent) => {
			return {
				status: !!Markup.countElements(pageContent.content, 'strong')
			};
		}
	},
	{
		id: 'post-title-length',
		label: window?.t?.CHECK_POST_TITLE_LENGTH,
		section: 'content',
		test: (pageContent) => {
			let {content} = pageContent;
			const markup = Markup.createMarkupEl(content);
			const title = markup.querySelector('h1') ? markup.querySelector('h1').textContent : '';
			return {
				status: TextUtils.countWords(title) <= 10
			}
		},
		inPro: true,
	},
	{
		id: 'minimal-word-count',
		label: window?.t?.CHECK_MINIMAL_WORD_COUNT,
		section: 'content',
		inPro: true,
		needsSeoData: true,
		test: (pageContent, settings) => {
			let {content, optimal} = pageContent;
			let text = Markup.stripTags(content);
			let wordCount = TextUtils.countWords(text);
			let minimalWordCount = 300;
			if (settings.minContentLength) {
				minimalWordCount = settings.minContentLength;
			} else if (optimal.optimalWordCount) {
				minimalWordCount = Math.round(0.7 * optimal.optimalWordCount);
			}
			return {
				status: wordCount >= minimalWordCount,
				optimalMin: minimalWordCount,
			}
		}
	},
	{
		id: 'optimal-word-count',
		label: window?.t?.CHECK_OPTIMAL_WORD_COUNT,
		inPro: true,
		section: 'content',
		valueFieldName: 'optimalWordNumber',
		needsSeoData: true,
		test: (pageContent, settings) => {
			var {content, optimal} = pageContent;
			const {optimalWordCount} = optimal;

			if (!(settings.minContentLength && settings.maxContentLength) && !optimalWordCount) {
				return {
					status: false
				};
			}
			let minValue = parseInt(settings.minContentLength) || Math.round(0.7 * optimalWordCount);
			let maxValue = parseInt(settings.maxContentLength) || Math.round(1.3 * optimalWordCount);

			let wordCount = 0;
			if (!!content) {
				content = content.replaceAll('</', ' </');
				content = Markup.stripTags(content);
				wordCount = TextUtils.countWords(content);
			}

			return {
				status: wordCount >= minValue && wordCount <= maxValue,
				optimalMin: minValue,
				optimalMax: maxValue,
				value: wordCount
			}
		}
	},
	{
		id: 'optimal-heading-number',
		label: window?.t?.CHECK_OPTIMAL_HEADING_NUMBER,
		inPro: true,
		section: 'content',
		valueFieldName: 'optimalHeadingNumber',
		needsSeoData: true,
		test: (pageContent) => {
			var {content, optimal} = pageContent;
			const {optimalHeadingCount} = optimal;

			if (!optimalHeadingCount) {
				return {
					status: false,
				}
			}

			const minHeadingCount = Math.round(0.7 * optimalHeadingCount);
			const maxHeadingCount = Math.round(1.3 * optimalHeadingCount);
			const headingCount = !!content ? Markup.countElements(content, 'h2, h3, h4, h5, h6') : 0;

			return {
				status: headingCount >= minHeadingCount && headingCount <= maxHeadingCount,
				optimalMin: minHeadingCount,
				optimalMax: maxHeadingCount > 30 ? 30 : maxHeadingCount,
				value: headingCount,
			}
		}
	},
	{
		id: 'optimal-image-number',
		label: window?.t?.CHECK_OPTIMAL_IMAGE_NUMBER,
		inPro: true,
		section: 'content',
		valueFieldName: 'optimalImageNumber',
		excludeFromScore: true,
		needsSeoData: true,
		test: (pageContent, settings) => {
			var {content, optimal} = pageContent;
			const {optimalImageCount} = optimal;
			if (!optimalImageCount && optimalImageCount !== 0) {
				return {
					status: 'info',
				}
			}

			const minImageCount = Math.round(0.7 * optimalImageCount);
			const maxImageCount = Math.round(1.3 * optimalImageCount);
			const imageCount = !!content ? Markup.countElements(content, 'img') : 0;

			return {
				status: 'info',
				optimalMin: minImageCount,
				optimalMax: maxImageCount,
				value: imageCount
			}
		}
	},
	{
		id: 'no-disallowed-words',
		label: window?.t?.CHECK_NO_DISALLOWED_WORDS,
		section: 'content',
		test: (pageContent, settings) => {
			let {content} = pageContent;
			if (!content || !settings.disallowedWords) {
				return {
					status: true
				};
			}
			content = Markup.stripTags(content).toLowerCase();
			content = content.replace(/(\r\n|\n|\r)/gm, ' ');
			content = content.replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-./:;<=>?@[\]^_`{|}~]/g, ' ');
			const words = content.split(' ');
			const bad = settings.disallowedWords.split(/\r?\n/).map((word) => word.trim());
			let result = words.filter((word) => bad.includes(word));
			return {
				status: !result.length,
			}
		},
		showProblem: (settings, content) => {
			if (!content) {
				return false;
			}
			const bad = settings.disallowedWords.split(/\r?\n/).map((word) => word.trim());

			let noTags = Markup.stripTags(content);
			noTags = noTags.replace(/(\r\n|\n|\r)/gm, ' ');
			noTags = noTags.replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-./:;<=>?@[\]^_`{|}~]/g, ' ');
			const words = noTags.split(' ');

			const markup = Markup.createMarkupEl(content);
			const marks = markup.querySelectorAll('mark');
			if (marks.length) {
				markup.innerHTML = markup.innerHTML.replaceAll('<mark>','').replaceAll('</mark>','');
			}

			words.forEach((word) => {
				if (!word) {
					return;
				}
				if (bad.includes(word.toLocaleLowerCase())) {
					markup.innerHTML = markup.replaceAll(word, `<mark>${word}</mark>`);
				}
			});
			return markup.innerHTML !== content ? markup.innerHTML : content;
		}
	},
	{
		id: 'uppercase-not-overused',
		label: window?.t?.CHECK_UPPERCASE_NOT_OVERUSED,
		section: 'content',
		inPro: true,
		test: (pageContent, settings) => {
			var {content} = pageContent;
			if (!content) {
				return {
					status: true
				}
			}

			content = Markup.stripTags(content);
			content = content.replace(/(\r\n|\n|\r)/gm, ' ');
			content = content.replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-./:;<=>?@[\]^_`{|}~]/g, ' ');
			const words = content.split(' ').filter((word) => word.trim());

			let uppercaseCount = 0;
			let status = true;
			words.forEach((word) => {
				if (word === word.toUpperCase()) {
					uppercaseCount ++;
				} else {
					uppercaseCount = 0;
				}

				if (uppercaseCount >= 3) {
					status = false;
				}
			});

			return {
				status: status
			}
		},
	},
	{
		id: 'keyword-exists',
		label: window?.t?.CHECK_KEYWORD_EXISTS,
		section: 'keyword',
		test: (pageContent) => {
			return {
				status: !!pageContent.keyword
			}
		}
	},
	{
		id: 'keyword-in-h1',
		label: window?.t?.CHECK_KEYWORD_IN_H1,
		section: 'keyword',
		test: (pageContent) => {
			var {keyword, content} = pageContent;
			return {
				status: Markup.isPhraseInAnyElement(keyword, content, 'h1')
			}
		}
	},

	{
		id: 'keyword-not-in-ext-link',
		label: window?.t?.CHECK_KEYWORD_NOT_IN_EXT_LINK,
		section: 'keyword',
		test: (pageContent) => {
			const {keyword, content, siteUrl} = pageContent;
			if (!keyword) {
				return {
					status: true
				};
			}

			const markup = Markup.createMarkupEl(content);
			var result = false;
			let siteAddress;
			try {
				siteAddress = new URL(siteUrl);
			} catch {
				return {
					status: true
				};
			}

			const links = markup.querySelectorAll('a');
			links.forEach(link => {
				const url = link.getAttribute('href') || '';
				result = !url.includes('http://' + siteAddress.hostname) &&
					!url.includes('https://' + siteAddress.hostname) &&
					url.substring(0, 1) !== '/' && url.substring(0, 2) !== './' &&
					TextUtils.isPhraseInText(keyword, link.textContent);
			});

			return {
				status: !result
			}
		}
	},
	{
		id: 'keyword-in-first-words',
		label: window?.t?.CHECK_KEYWORD_IN_FIRST_WORDS,
		section: 'keyword',
		test: (pageContent) => {
			var {keyword, content} = pageContent;
			if (!keyword) {
				return {
					status: false
				};
			}

			keyword = keyword.trim().toLowerCase();
			content = Markup.stripTags(content);

			var words = content.toLowerCase().split(/\s|\n/);
			words = words.filter((el) => { return el; });
			const limit = words.length >= 100 ? 100 : words.length;
			words = words.splice(0, limit);

			if (!TextUtils.isPhraseInText(keyword, words.join(' '))) {
				return {
					status: false
				};
			}

			let keywordWordsCount = keyword.split(' ');
			if (keywordWordsCount.length > 1) {
				return {
					status: true
				};
			}

			if (words.length) {
				for (let i = 0; i < limit; i++) {
					words[i] = words[i].replace('.', '');
					words[i] = words[i].replace(',', '');
					words[i] = words[i].replace('?', '');
					words[i] = words[i].replace('!', '');
					words[i] = words[i].replace(':', '');
					words[i] = words[i].replace(';', '');
					words[i] = words[i].replace('-', '');
				}
			}

			return {
				status: words.includes(keyword)
			}
		}
	},
	{
		id: 'keyword-in-last-words',
		label: window?.t?.CHECK_KEYWORD_IN_LAST_WORDS,
		section: 'keyword',
		inPro: true,
		test: (pageContent) => {
			var {keyword, content} = pageContent;
			if (!keyword) {
				return {
					status: false
				};
			}

			content = Markup.stripTags(content);
			keyword = keyword.trim().toLowerCase();

			var words = content.toLowerCase().split(/\s|\n/);
			words = words.filter((el) => el);
			words = words.slice(Math.max(words.length - 100, 0));
			const limit = words.length >= 100 ? 100 : words.length;

			if (!TextUtils.isPhraseInText(keyword, words.join(' '))) {
				return {
					status: false
				};
			}

			let keywordWordsCount = keyword.split(' ');
			if (keywordWordsCount.length > 1) {
				return {
					status: true
				};
			}

			if (words.length) {
				for (let i = 0; i < limit; i++) {
					words[i] = words[i].replace('.', '');
					words[i] = words[i].replace(',', '');
					words[i] = words[i].replace('?', '');
					words[i] = words[i].replace('!', '');
					words[i] = words[i].replace(':', '');
					words[i] = words[i].replace(';', '');
				}
			}

			return {
				status: words.includes(keyword)
			}
		}
	},
	{
		id: 'keyword-in-h2',
		label: window?.t?.CHECK_KEYWORD_IN_H2,
		section: 'keyword',
		inPro: true,
		test: (pageContent) => {
			const {keyword, content} = pageContent;
			return {
				status: Markup.isPhraseInAnyElement(keyword, content, 'h2')
			}
		}
	},
	{
		id: 'keyword-in-image-filename',
		label: window?.t?.CHECK_KEYWORD_IN_IMAGE_FILENAME,
		section: 'keyword',
		inPro: true,
		excludeFromScore: true,
		test: (pageContent) => {
			const {keyword, content} = pageContent;

			if (!keyword) {
				return {
					status: false
				};
			}

			let result = 'info';
			const markup = Markup.createMarkupEl(content);
			const images = markup.querySelectorAll('img');
			if (images) {
				images.forEach((image) => {
					let url = image.getAttribute('src');
					let lastSlash = url.lastIndexOf('/');
					let filename = url.substring(lastSlash);
					if (TextUtils.isPhraseInText(TextUtils.slugify(keyword), filename)) {
						result = true;
					}
				});
			}

			return {
				status: result
			}
		}
	},
	{
		type: 'configField',
		section: 'internal-links',
		fieldName: 'domain',
		fieldLabel: 'Site URL',
		fieldType: 'url',
		contentField: 'siteUrl',
		callbackPropName: 'domainCallback',
	},
	{
		id: 'internal-links-present',
		label: window?.t?.CHECK_INTERNAL_LINKS_PRESENT,
		section: 'internal-links',
		test: (pageContent) => {
			let {content, siteUrl} = pageContent;
			if (!siteUrl) {
				return  {
					status: false
				};
			}
			const markup = Markup.createMarkupEl(content);
			const links = markup.querySelectorAll('a');
			let siteAddress;
			try {
				siteAddress = new URL(siteUrl);
			} catch {
				return {
					status: false
				};
			}

			var internalLinksPresent = false;
			links.forEach(link => {
				var url = link.getAttribute('href') || '';
				if (!url) {
					return {
						status: false
					};
				}
				if (url.includes('http://' + siteAddress.hostname) || url.includes('https://' + siteAddress.hostname) || url.substring(0, 1) === '/' || url.substring(0, 2) === './') {
					internalLinksPresent = true;
				}
			});

			return  {
				status: internalLinksPresent
			}
		},
	},
	{
		id: 'readability',
		label: window?.t?.CHECK_READABILITY,
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			let {content} = pageContent;
			if (!content) {
				return {
					value: 'N/A',
					comment: '',
					status: 'nok',
				}
			}
			content = Markup.stripTags(content);

			var sentences = content.split(/\.|\?|!/);
			sentences = sentences.map(sentence => {
				return sentence.trim();
			})
			sentences = sentences.filter(sentence => {
				return sentence && sentence !== " " && sentence !== '\n';
			});

			content = content.replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-./:;<=>?@[\]^_`{|}~]/g, ' ');

			var words = content.split(' ');
			words = words.map(word => {
				return word.trim();
			})
			words = words.filter(word => {
				return word && word !== '' && word !== '\n';
			})
			const syllableCount = TextUtils.countSyllables(content);

			var score = 206.835 - 1.015 * (words.length / sentences.length) - 84.6 * (syllableCount / words.length);
			score = score.toFixed(2);
			if (score < 0) {
				score = 0;
			} else if (score > 100) {
				score = 100;
			}
			var comment = '';
			var status = 'info';

			switch (true) {
				case isNaN(score):
					score = 'N/A';
					comment = '';
					break;
				case score > 90:
					comment = window?.t?.READING_DIFF90;
					break;
				case score > 80 && score <= 90:
					comment = window?.t?.READING_DIFF80;
					break;
				case score > 70 && score <= 80:
					comment = window?.t?.READING_DIFF70;
					break;
				case score > 60 && score <= 70:
					comment = window?.t?.READING_DIFF60;
					break;
				case score > 50 && score <= 60:
					comment = window?.t?.READING_DIFF50;
					break;
				case score > 30 && score <= 50:
					comment = window?.t?.READING_DIFF30;
					break;
				case score > 10 && score <= 30:
					comment = window?.t?.READING_DIFF10;
					break;
				default:
					comment = window?.t?.READING_DIFF0;
					break;
			}

			if (comment) {
				comment = `(${comment})`;
			}

			return {
				value: score,
				comment: comment,
				status: status
			}
		}
	},
	{
		id: 'words',
		label: window?.t?.CHECK_WORDS,
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			let text = Markup.stripTags(pageContent.content);
			return {
				value: TextUtils.countWords(text),
				status: 'info'
			}
		}
	},
	{
		id: 'chars',
		label: window?.t?.CHECK_CHARS,
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			let text = Markup.stripTags(pageContent.content);
			return {
				value: text.length || 0,
				status: 'info',
			}
		}
	},
	{
		id: 'sentences',
		label: window?.t?.CHECK_SENTENCES,
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			let {content} = pageContent;
			content = Markup.stripTags(content);
			content = content.replace(/(\r\n|\n|\r)/gm, ' ');

			var sentences = content.split(/\.|\?|!/);
			sentences = sentences.map(sentence => {
				return sentence.trim();
			})
			sentences = sentences.filter(sentence => {
				return sentence && sentence !== " " && sentence !== '\n';
			});

			return {
				value: sentences.length || 0,
				status: 'info',
			}
		}
	},
	{
		id: 'paragraphs',
		label: window?.t?.CHECK_PARAGRAPHS,
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			pageContent = pageContent.content;
			return {
				value: Markup.countElements(pageContent, 'p'),
				status: 'info',
			}
		}
	},
	{
		id: 'headings',
		label: window?.t?.CHECK_HEADINGS,
		inPro: true,
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			return {
				value: Markup.countElements(pageContent.content, 'h1, h2, h3, h4, h5, h6'),
				status: 'info',
			}
		}
	},
	{
		id: 'images',
		label: window?.t?.CHECK_IMAGES,
		inPro: true,
		section: 'info',
		excludeFromScore: true,
		test: (pageContent) => {
			return {
				value: Markup.countElements(pageContent.content, 'img'),
				status: 'info',
			}
		}
	},
	{
		id: 'est-reading-time',
		label: window?.t?.CHECK_EST_READING_TIME,
		section: 'info',
		order: 'label value',
		excludeFromScore: true,
		test: (pageContent) => {
			let {content} = pageContent;
			var wordCount = TextUtils.countWords(content);
			var wpm = 225;
			var mins = Math.floor(wordCount / wpm);
			var secs = Math.floor(wordCount % wpm / (wpm / 60));
			return {
				value: `${mins} min ${secs} s`,
				status: 'info',
			}
		}
	},
];

export default checks;